import { render, staticRenderFns } from "./WordsEditor.vue?vue&type=template&id=a8cbf086"
import script from "./WordsEditor.vue?vue&type=script&lang=js"
export * from "./WordsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports